import React, { useState, useEffect } from 'react';
import '../../../entrydoor.css';

// Visible only when the selected size has frame === 1.

const DoorLiteFrame = ({ value = 'StainablePVC', onChange, isVisible = 0, label = 'Lite Frame' }) => {
    const [selected, setSelected] = useState(value);

    useEffect(() => {
        if (isVisible === 1) {
            setSelected('StainablePVC');
            onChange('StainablePVC');
        }
    }, [isVisible]);

    if (isVisible !== 1) return null;

    const handleChange = (e) => {
        setSelected(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label htmlFor="DoorLiteFrame">{label}</label>
            <select id="DoorLiteFrame" value={selected} onChange={handleChange}>
                <option value="StainablePVC">Stainable PVC</option>
                <option value="RegaleadClay">Regalead Clay</option>
            </select>
        </div>
    );
};

export default DoorLiteFrame;
